import React, { useMemo, useState, useContext } from "react";
import "./index.less";
import { getImgSrc, getThumbUrl, getFileUrl } from "@/utils/chat/index";
import { ChatMessageType, ImageChatMessage, VideoChatMessage, MessageStatus } from "@/types/chat";
import { videoDurationFromat } from "@/utils/date";
import historyVideoIcon from "@/assets/images/history-video.png";
import errImg from "@/assets/img/empty/err-img_media.png";
import expiredImg from "@/assets/img/empty/expired-img_media.png";
import { isGifImage } from "@/components/chat/utils/image";
import { detectOS } from "@/utils";
import debounce from "lodash/debounce";
import imgLoading from "@/assets/img/img-loading.png";
import ImService from "@/server/ImService";
import { connect } from "dvajs";
import { checkFileIsExpired, getDownloadFileRes } from "@/components/chat/utils/commonMessageModal";
import GlobalContext, { GlobalContextConfig } from "@/context/GlobalContext";
import { message as toast } from "antd";
import i18n from "@/i18n";

interface ImageItemProps {
  message: ImageChatMessage | VideoChatMessage;
  previewFunc: (message: any) => void;
  updateSessionMessageMid: Function;
}

function ImageItem(props: ImageItemProps) {
  const { message, previewFunc, updateSessionMessageMid } = props;
  const [isError, setIsError] = useState(message.statusType === MessageStatus.EXPIRED);
  const [isExpired, setIsExpired] = useState(message.statusType === MessageStatus.EXPIRED);
  const [isLoading, setIsLoading] = useState(true);
  const { appRuntimeEnv } = useContext<GlobalContextConfig>(GlobalContext);
  const {
    im,
    fileService: { imAppKey }
  } = appRuntimeEnv;
  const { imageSource, propItems, isVideo, duration } = useMemo(() => {
    let imageSource = message.url;
    let imageWidth = 80;
    let imageHeight = 80;
    let isVideo = false;
    let duration = 0;
    const propItems: Record<string, string> = {};
    if (message.type === ChatMessageType.IMAGE) {
      imageWidth = (message as ImageChatMessage).width || 80;
      imageHeight = (message as ImageChatMessage).height || 80;
    } else if (message.type === ChatMessageType.VIDEO) {
      isVideo = true;
      imageSource = (message as VideoChatMessage).thumbnail;
      imageWidth = (message as VideoChatMessage).thumbWidth || 80;
      imageHeight = (message as VideoChatMessage).thumbHeight || 80;
      duration = (message as VideoChatMessage).duration || 0;
    }
    imageSource = getImgSrc(imageSource);
    // 小于100 * 100的图 直接显示原图
    if (message.type === ChatMessageType.IMAGE) {
      if (
        !(
          (message as any).fileType?.includes("image/gif") ||
          isGifImage(message.url) ||
          detectOS() === "Mac"
        )
      ) {
        if (imageWidth && imageWidth < 200 && imageHeight && imageHeight < 200) {
          imageSource = getThumbUrl(imageSource, 100, 100);
        } else {
          imageSource = getThumbUrl(imageSource, 600, 400);
        }
      }
    }

    //
    propItems.backgroundImage = `url(${imageSource})`;
    if (imageWidth > imageHeight) {
      propItems.backgroundSize = "auto 100%";
    } else {
      propItems.backgroundSize = "100% auto";
    }
    // propItems.padding = '12px';
    return { imageSource, imageWidth, imageHeight, propItems, isVideo, duration };
  }, [message]);

  const checkExpired = async () => {
    console.log("checkExpire>", message);
    if (isError && !isExpired) {
      const url = getFileUrl(message.url);
      const resJSON = await getDownloadFileRes(url);
      if (resJSON.response?.indexOf("1017005") > -1) {
        toast.error(i18n.t("chat:file-expired-tip"));
        const imService = ImService.getInstance();
        imService.updateMessage(message.sessionId, message.mid, {
          statusType: MessageStatus.EXPIRED
        });
        updateSessionMessageMid({
          sessionId: message.sessionId,
          sendResult: { body: { ...message, statusType: MessageStatus.EXPIRED } }
        });
        setIsError(true);
        setIsExpired(true);
        return;
      }
    }
    const isFileExpired = checkFileIsExpired({
      // expiredAppKey: imAppKey,
      message,
      updateSessionMessageMid,
      expiredTime: im.fileExpiredTime,
      type: isVideo ? "video" : "image"
    });
    if (isFileExpired) {
      setIsError(true);
      setIsExpired(true);
      return true;
    }
    return false;
  };

  const handleClickImg = async (message: any) => {
    const isExpired = await checkExpired();
    if (isExpired) return;
    previewFunc(message);
  };

  return (
    <div className="history-media-item">
      {isLoading && (
        <div className="media-image_loading">
          <img src={imgLoading} />
        </div>
      )}
      <img
        className="media-image_loaded"
        src={imageSource}
        onClick={debounce(() => handleClickImg(message), 500)}
        onLoad={() => {
          setIsLoading(false);
        }}
        style={{ display: isLoading || isError || isExpired ? "none" : "block" }}
        onError={() => {
          // onImgExpired();
          setIsError(true);
          setIsLoading(false);
        }}
      />
      {isError && (
        <img
          className={`media-image_error ${isExpired ? "expired" : ""}`}
          src={isExpired ? expiredImg : errImg}
          onClick={debounce(() => checkExpired(), 500)}
        />
      )}
      {isVideo && (
        <div className="video-info">
          <img src={historyVideoIcon} />
          <span className="duration">{videoDurationFromat(duration)}</span>
        </div>
      )}
    </div>
  );
}

function mapStateToProps() {
  return {};
}

function mapDispatchToProps(dispatch: any) {
  return {
    updateSessionMessageMid(data: { sendResult: any; sessionId: String }) {
      return dispatch({ type: "chat/updateSessionMessageMid", payload: data });
    }
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(ImageItem);
